module.exports = __webpack_public_path__ + "static/img/icon_virtual@2x.82e19c25.png";